'use client';

import React from 'react';
import Link from 'next/link';
import { trackClickEvent } from '@/utils/site-track';
import SvgLogo from '@/components/icons/SvgLogo';

const Logo = (props: { href: string; className?: string }) => {
  const { href, className } = props;
  return (
    <Link
      href={href}
      className={className}
      onClick={(e) => {
        trackClickEvent(e, true);
      }}
      data-ele-group="navigation"
      data-ele-id="btn_logo"
    >
      <SvgLogo />
    </Link>
  );
};

export default Logo;
